import React from 'react';
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import ContactSupportOutlinedIcon from '@material-ui/icons/ContactSupportOutlined';
import HotelOutlinedIcon from '@material-ui/icons/HotelOutlined';
import RestaurantRoundedIcon from '@material-ui/icons/RestaurantRounded';
import { _T, _F, pluralizeDays } from 'appI18n';
import IconText from 'react-components/IconText';
const useStyles = makeStyles(theme => ({
    root: {},
    feature: {
        borderBottom: `1px dashed ${theme.palette.secondary.light}`,
        paddingBottom: 2,
        cursor: "pointer",
        marginBottom: theme.spacing(1),
    },
    featureWarn: {
        "$feature&": { borderColor: theme.palette.warning.main }
    },
    featureGood: {
        "$feature&": { borderColor: theme.palette.success.main }
    },
    icon: {
        color: theme.palette.secondary.main,
        "$featureWarn &": { color: theme.palette.warning.main },
        "$featureGood &": { color: theme.palette.success.main },
    },
    group: { width: 'auto' }
}));
export default function TourSummary(props) {
    const classes = useStyles();
    const dateStart = moment.utc(props.tourStart);
    const dateEnd = dateStart.clone().add(Math.max(0, props.tourDuration - 1), "days");
    const tourDurationText = `${props.tourDuration} ${pluralizeDays(props.tourDuration)}`;
    return (React.createElement(Grid, { container: true, spacing: 5, wrap: "wrap" },
        React.createElement(Grid, { item: true, container: true, className: classes.group },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement("div", null,
                    React.createElement(Tooltip, { title: _F('TOUR_DURATION_FROM_TO', dateStart.format('L'), dateEnd.format('L')), arrow: true },
                        React.createElement(IconText, { className: classes.feature, text: _F('TOUR_DATE_AND_DURATION_SHORT', dateStart.format('L'), tourDurationText), icon: React.createElement(CalendarTodayOutlinedIcon, { className: classes.icon }) }))),
                props.accmmd &&
                    React.createElement("div", null,
                        React.createElement(Tooltip, { title: props.accmmd.immediateConfirm ? _T.TOUR_AVAILABILITY_AVAILABLE_LONG : _T.TOUR_AVAILABILITY_ONREQUEST_LONG, arrow: true }, props.accmmd.immediateConfirm
                            ? (React.createElement(IconText, { icon: React.createElement(CheckCircleOutlinedIcon, { className: classes.icon }), text: _T.TOUR_AVAILABLE, className: `${classes.feature} ${classes.featureGood}` }))
                            : (React.createElement(IconText, { icon: React.createElement(ContactSupportOutlinedIcon, { className: classes.icon }), text: _T.TOUR_ONREQUEST, className: `${classes.feature} ${classes.featureWarn}` })))))),
        React.createElement(Grid, { item: true, container: true, className: classes.group },
            React.createElement(Grid, { item: true, xs: 12 },
                props.accmmd &&
                    React.createElement("div", null,
                        React.createElement(Tooltip, { title: _T.COMMON_ACCOMMODATION, arrow: true },
                            React.createElement(IconText, { className: classes.feature, text: `${props.accmmd.roomTypeName}, ${props.accmmd.roomCategoryName}`, icon: React.createElement(HotelOutlinedIcon, { className: classes.icon }) }))),
                props.accmmd &&
                    React.createElement("div", null,
                        React.createElement(Tooltip, { title: _T.COMMON_MEAL, arrow: true },
                            React.createElement(IconText, { className: classes.feature, text: `${props.accmmd.mealTypeName}`, icon: React.createElement(RestaurantRoundedIcon, { className: classes.icon }) })))))));
}
